import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';

import { useToaster } from '@crossnokaye/ux-common';

import { setQueryClientToastHandlers } from '@/queries/query-utils';
import { queryClient } from '@/singletons';

interface QueryProviderProps {
  children: React.ReactNode;
}

export const QueryProvider = ({ children }: QueryProviderProps) => {
  const { addErrorToast, addWarningToast } = useToaster();

  useEffect(() => {
    setQueryClientToastHandlers(addErrorToast, addWarningToast);
  }, [addErrorToast, addWarningToast]);

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
